import LoginForm from "components/Organisms/login/forms/loginForm";

export default function Login() {
  return <LoginForm />;
}
